var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 0c-6.617 0-12 5.383-12 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12zm5.736 16.677c-0.194 0.21-0.462 0.323-0.736 0.323-0.125 0-0.251-0.023-0.372-0.071l-4.628-1.852-4.628 1.852c-0.385 0.154-0.826 0.054-1.107-0.251-0.281-0.306-0.344-0.753-0.159-1.125l5-10c0.339-0.678 1.45-0.678 1.789 0l5 10c0.185 0.371 0.122 0.819-0.159 1.124z",
    fill: "#000",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.1885ea1a83f6f17ca7caf6dfce5b6f2f.svg";
export { ForwardRef as ReactComponent };